// Ascension tiers stack modifiers to make each level harder.
// Each level includes all previous modifiers.

export const ASCENSIONS = [
  { level: 0, name: 'CHILL', desc: 'Base game. For gooners.', modifiers: {} },
  { level: 1, name: 'MID',  desc: 'Elites are 20% beefier.', modifiers: { eliteHpMult: 1.2 } },
  { level: 2, name: 'SPICY', desc: '+ Enemies gain +1 STR.', modifiers: { eliteHpMult: 1.2, enemyStrength: 1 } },
  { level: 3, name: 'CURSED', desc: '+ You start with -5 max HP.', modifiers: { eliteHpMult: 1.2, enemyStrength: 1, hpDelta: -5 } },
  { level: 4, name: 'CRINGE', desc: '+ Shops cost +25% more.', modifiers: { eliteHpMult: 1.2, enemyStrength: 1, hpDelta: -5, shopMult: 1.25 } },
  { level: 5, name: 'ABSOLUTE SLOP', desc: '+ Bosses are 20% chunkier.', modifiers: { eliteHpMult: 1.2, enemyStrength: 1, hpDelta: -5, shopMult: 1.25, bossHpMult: 1.2 } },
];

export function ascById(level) {
  return ASCENSIONS[Math.max(0, Math.min(ASCENSIONS.length - 1, level))];
}
